import z from "zod/v4";

export const applicationAdditionalTrackingTokenSchema = z.object({
  id: z.number(),
  token: z.string(),
});

export const applicationMetadataSchema = z.object({
  id: z.number(),
  key: z.string(),
  value: z.string(),
});

export const applicationMetadataCreatePayloadSchema = z.object({
  key: z.string(),
  value: z.string(),
});

export const applicationMetadataSyncPayloadSchema = z.object({
  metadata_ids: z.array(z.number()),
  funder_ids: z.array(z.string()),
});

export const resubmitPlacementResponseSchema = z.object({
  resubmitted: z.boolean(),
});
